import { useState, useRef } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { toast } from "sonner";
import { Briefcase, HardHat, Sparkles, Eye, EyeOff } from "lucide-react";

const ROLES = [
 { id: "worker", title: "Staff", desc: "Apply to event gigs near you", icon: HardHat },
  { id: "manager", title: "Manager", desc: "Post events, hire crew", icon: Briefcase },
  { id: "freelancer", title: "Freelancer", desc: "Sell your services online", icon: Sparkles },
];

const COUNTRY_CODES = [
  { code: "+91", flag: "🇮🇳", name: "India" },
  { code: "+93", flag: "🇦🇫", name: "Afghanistan" },
  { code: "+355", flag: "🇦🇱", name: "Albania" },
  { code: "+213", flag: "🇩🇿", name: "Algeria" },
  { code: "+376", flag: "🇦🇩", name: "Andorra" },
  { code: "+244", flag: "🇦🇴", name: "Angola" },
  { code: "+54", flag: "🇦🇷", name: "Argentina" },
  { code: "+374", flag: "🇦🇲", name: "Armenia" },
  { code: "+61", flag: "🇦🇺", name: "Australia" },
  { code: "+43", flag: "🇦🇹", name: "Austria" },
  { code: "+994", flag: "🇦🇿", name: "Azerbaijan" },
  { code: "+973", flag: "🇧🇭", name: "Bahrain" },
  { code: "+880", flag: "🇧🇩", name: "Bangladesh" },
  { code: "+375", flag: "🇧🇾", name: "Belarus" },
  { code: "+32", flag: "🇧🇪", name: "Belgium" },
  { code: "+501", flag: "🇧🇿", name: "Belize" },
  { code: "+229", flag: "🇧🇯", name: "Benin" },
  { code: "+975", flag: "🇧🇹", name: "Bhutan" },
  { code: "+591", flag: "🇧🇴", name: "Bolivia" },
  { code: "+387", flag: "🇧🇦", name: "Bosnia" },
  { code: "+267", flag: "🇧🇼", name: "Botswana" },
  { code: "+55", flag: "🇧🇷", name: "Brazil" },
  { code: "+673", flag: "🇧🇳", name: "Brunei" },
  { code: "+359", flag: "🇧🇬", name: "Bulgaria" },
  { code: "+226", flag: "🇧🇫", name: "Burkina Faso" },
  { code: "+257", flag: "🇧🇮", name: "Burundi" },
  { code: "+855", flag: "🇰🇭", name: "Cambodia" },
  { code: "+237", flag: "🇨🇲", name: "Cameroon" },
  { code: "+1", flag: "🇨🇦", name: "Canada" },
  { code: "+236", flag: "🇨🇫", name: "Central African Republic" },
  { code: "+235", flag: "🇹🇩", name: "Chad" },
  { code: "+56", flag: "🇨🇱", name: "Chile" },
  { code: "+86", flag: "🇨🇳", name: "China" },
  { code: "+57", flag: "🇨🇴", name: "Colombia" },
  { code: "+269", flag: "🇰🇲", name: "Comoros" },
  { code: "+242", flag: "🇨🇬", name: "Congo" },
  { code: "+506", flag: "🇨🇷", name: "Costa Rica" },
  { code: "+385", flag: "🇭🇷", name: "Croatia" },
  { code: "+53", flag: "🇨🇺", name: "Cuba" },
  { code: "+357", flag: "🇨🇾", name: "Cyprus" },
  { code: "+420", flag: "🇨🇿", name: "Czech Republic" },
  { code: "+45", flag: "🇩🇰", name: "Denmark" },
  { code: "+253", flag: "🇩🇯", name: "Djibouti" },
  { code: "+593", flag: "🇪🇨", name: "Ecuador" },
  { code: "+20", flag: "🇪🇬", name: "Egypt" },
  { code: "+503", flag: "🇸🇻", name: "El Salvador" },
  { code: "+251", flag: "🇪🇹", name: "Ethiopia" },
  { code: "+679", flag: "🇫🇯", name: "Fiji" },
  { code: "+358", flag: "🇫🇮", name: "Finland" },
  { code: "+33", flag: "🇫🇷", name: "France" },
  { code: "+241", flag: "🇬🇦", name: "Gabon" },
  { code: "+220", flag: "🇬🇲", name: "Gambia" },
  { code: "+995", flag: "🇬🇪", name: "Georgia" },
  { code: "+49", flag: "🇩🇪", name: "Germany" },
  { code: "+233", flag: "🇬🇭", name: "Ghana" },
  { code: "+30", flag: "🇬🇷", name: "Greece" },
  { code: "+502", flag: "🇬🇹", name: "Guatemala" },
  { code: "+224", flag: "🇬🇳", name: "Guinea" },
  { code: "+592", flag: "🇬🇾", name: "Guyana" },
  { code: "+509", flag: "🇭🇹", name: "Haiti" },
  { code: "+504", flag: "🇭🇳", name: "Honduras" },
  { code: "+852", flag: "🇭🇰", name: "Hong Kong" },
  { code: "+36", flag: "🇭🇺", name: "Hungary" },
  { code: "+354", flag: "🇮🇸", name: "Iceland" },
  { code: "+62", flag: "🇮🇩", name: "Indonesia" },
  { code: "+98", flag: "🇮🇷", name: "Iran" },
  { code: "+964", flag: "🇮🇶", name: "Iraq" },
  { code: "+353", flag: "🇮🇪", name: "Ireland" },
  { code: "+972", flag: "🇮🇱", name: "Israel" },
  { code: "+39", flag: "🇮🇹", name: "Italy" },
  { code: "+225", flag: "🇨🇮", name: "Ivory Coast" },
  { code: "+1876", flag: "🇯🇲", name: "Jamaica" },
  { code: "+81", flag: "🇯🇵", name: "Japan" },
  { code: "+962", flag: "🇯🇴", name: "Jordan" },
  { code: "+7", flag: "🇰🇿", name: "Kazakhstan" },
  { code: "+254", flag: "🇰🇪", name: "Kenya" },
  { code: "+965", flag: "🇰🇼", name: "Kuwait" },
  { code: "+996", flag: "🇰🇬", name: "Kyrgyzstan" },
  { code: "+856", flag: "🇱🇦", name: "Laos" },
  { code: "+371", flag: "🇱🇻", name: "Latvia" },
  { code: "+961", flag: "🇱🇧", name: "Lebanon" },
  { code: "+266", flag: "🇱🇸", name: "Lesotho" },
  { code: "+231", flag: "🇱🇷", name: "Liberia" },
  { code: "+218", flag: "🇱🇾", name: "Libya" },
  { code: "+370", flag: "🇱🇹", name: "Lithuania" },
  { code: "+352", flag: "🇱🇺", name: "Luxembourg" },
  { code: "+261", flag: "🇲🇬", name: "Madagascar" },
  { code: "+265", flag: "🇲🇼", name: "Malawi" },
  { code: "+60", flag: "🇲🇾", name: "Malaysia" },
  { code: "+960", flag: "🇲🇻", name: "Maldives" },
  { code: "+223", flag: "🇲🇱", name: "Mali" },
  { code: "+356", flag: "🇲🇹", name: "Malta" },
  { code: "+222", flag: "🇲🇷", name: "Mauritania" },
  { code: "+230", flag: "🇲🇺", name: "Mauritius" },
  { code: "+52", flag: "🇲🇽", name: "Mexico" },
  { code: "+373", flag: "🇲🇩", name: "Moldova" },
  { code: "+976", flag: "🇲🇳", name: "Mongolia" },
  { code: "+382", flag: "🇲🇪", name: "Montenegro" },
  { code: "+212", flag: "🇲🇦", name: "Morocco" },
  { code: "+258", flag: "🇲🇿", name: "Mozambique" },
  { code: "+95", flag: "🇲🇲", name: "Myanmar" },
  { code: "+264", flag: "🇳🇦", name: "Namibia" },
  { code: "+977", flag: "🇳🇵", name: "Nepal" },
  { code: "+31", flag: "🇳🇱", name: "Netherlands" },
  { code: "+64", flag: "🇳🇿", name: "New Zealand" },
  { code: "+505", flag: "🇳🇮", name: "Nicaragua" },
  { code: "+227", flag: "🇳🇪", name: "Niger" },
  { code: "+234", flag: "🇳🇬", name: "Nigeria" },
  { code: "+47", flag: "🇳🇴", name: "Norway" },
  { code: "+968", flag: "🇴🇲", name: "Oman" },
  { code: "+92", flag: "🇵🇰", name: "Pakistan" },
  { code: "+507", flag: "🇵🇦", name: "Panama" },
  { code: "+675", flag: "🇵🇬", name: "Papua New Guinea" },
  { code: "+595", flag: "🇵🇾", name: "Paraguay" },
  { code: "+51", flag: "🇵🇪", name: "Peru" },
  { code: "+63", flag: "🇵🇭", name: "Philippines" },
  { code: "+48", flag: "🇵🇱", name: "Poland" },
  { code: "+351", flag: "🇵🇹", name: "Portugal" },
  { code: "+974", flag: "🇶🇦", name: "Qatar" },
  { code: "+40", flag: "🇷🇴", name: "Romania" },
  { code: "+7", flag: "🇷🇺", name: "Russia" },
  { code: "+250", flag: "🇷🇼", name: "Rwanda" },
  { code: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "+221", flag: "🇸🇳", name: "Senegal" },
  { code: "+381", flag: "🇷🇸", name: "Serbia" },
  { code: "+232", flag: "🇸🇱", name: "Sierra Leone" },
  { code: "+65", flag: "🇸🇬", name: "Singapore" },
  { code: "+421", flag: "🇸🇰", name: "Slovakia" },
  { code: "+386", flag: "🇸🇮", name: "Slovenia" },
  { code: "+252", flag: "🇸🇴", name: "Somalia" },
  { code: "+27", flag: "🇿🇦", name: "South Africa" },
  { code: "+82", flag: "🇰🇷", name: "South Korea" },
  { code: "+211", flag: "🇸🇸", name: "South Sudan" },
  { code: "+34", flag: "🇪🇸", name: "Spain" },
  { code: "+94", flag: "🇱🇰", name: "Sri Lanka" },
  { code: "+249", flag: "🇸🇩", name: "Sudan" },
  { code: "+46", flag: "🇸🇪", name: "Sweden" },
  { code: "+41", flag: "🇨🇭", name: "Switzerland" },
  { code: "+963", flag: "🇸🇾", name: "Syria" },
  { code: "+886", flag: "🇹🇼", name: "Taiwan" },
  { code: "+992", flag: "🇹🇯", name: "Tajikistan" },
  { code: "+255", flag: "🇹🇿", name: "Tanzania" },
  { code: "+66", flag: "🇹🇭", name: "Thailand" },
  { code: "+228", flag: "🇹🇬", name: "Togo" },
  { code: "+216", flag: "🇹🇳", name: "Tunisia" },
  { code: "+90", flag: "🇹🇷", name: "Turkey" },
  { code: "+993", flag: "🇹🇲", name: "Turkmenistan" },
  { code: "+256", flag: "🇺🇬", name: "Uganda" },
  { code: "+380", flag: "🇺🇦", name: "Ukraine" },
  { code: "+971", flag: "🇦🇪", name: "United Arab Emirates" },
  { code: "+44", flag: "🇬🇧", name: "United Kingdom" },
  { code: "+1", flag: "🇺🇸", name: "United States" },
  { code: "+598", flag: "🇺🇾", name: "Uruguay" },
  { code: "+998", flag: "🇺🇿", name: "Uzbekistan" },
  { code: "+58", flag: "🇻🇪", name: "Venezuela" },
  { code: "+84", flag: "🇻🇳", name: "Vietnam" },
  { code: "+967", flag: "🇾🇪", name: "Yemen" },
  { code: "+260", flag: "🇿🇲", name: "Zambia" },
  { code: "+263", flag: "🇿🇼", name: "Zimbabwe" },
];

const USERNAME_REGEX = /^[a-z0-9._]+$/;

function CountryCodePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const inputRef = useRef(null);

  const selected = COUNTRY_CODES.find(c => c.code === value) || COUNTRY_CODES[0];

  const filtered = search.trim()
    ? COUNTRY_CODES.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase()) ||
        c.code.includes(search)
      )
    : COUNTRY_CODES;

  const select = (code) => {
    onChange(code);
    setOpen(false);
    setSearch("");
  };

  return (
    <div className="relative flex-shrink-0">
      {/* Trigger button — shows only flag + code when closed */}
      <button
        type="button"
        onClick={() => { setOpen(o => !o); setTimeout(() => inputRef.current?.focus(), 50); }}
        className="flex items-center gap-1 px-3 py-3 border-r border-slate-200 bg-background text-sm font-medium text-foreground hover:bg-muted transition rounded-l-xl"
        style={{ minWidth: "80px" }}
      >
        <span>{selected.flag}</span>
        <span>{selected.code}</span>
        <span className="text-muted-foreground text-xs ml-0.5">▾</span>
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute left-0 top-full mt-1 w-72 bg-popover border border-border rounded-xl shadow-2xl z-50 overflow-hidden">
          {/* Search input */}
          <div className="p-2 border-b border-border">
            <input
              ref={inputRef}
              type="text"
              className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg outline-none focus:border-brand"
              placeholder="Search country or code..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          {/* Results */}
          <div className="max-h-56 overflow-y-auto">
            {filtered.length === 0 && (
              <p className="text-sm text-muted-foreground text-center py-4">No results found</p>
            )}
            {filtered.map(c => (
              <button
                key={`${c.code}-${c.name}`}
                type="button"
                onClick={() => select(c.code)}
                className={`w-full flex items-center justify-between px-3 py-2.5 text-sm hover:bg-brand-tint transition text-left ${value === c.code && c.name === selected.name ? "bg-brand-tint/50 text-brand font-medium" : "text-foreground"}`}
              >
                <span className="flex items-center gap-2">
                  <span>{c.flag}</span>
                  <span>{c.name}</span>
                </span>
                <span className="text-muted-foreground font-mono text-xs">{c.code}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Backdrop to close */}
      {open && (
        <div className="fixed inset-0 z-40" onClick={() => { setOpen(false); setSearch(""); }} />
      )}
    </div>
  );
}

export default function Register() {
  const { register, refresh, formatApiErrorDetail } = useAuth();
  const [step, setStep] = useState(1);
  const [role, setRole] = useState("worker");
  const [form, setForm] = useState({ name: "", username: "", email: "", password: "", confirmPassword: "", countryCode: "+91", phone: "", companyName: "" });
  const [usernameError, setUsernameError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirect") || "/";
  const workspace = searchParams.get("workspace");

  const validateUsername = (val) => {
    if (!val) return "Username is required";
    if (val.length < 3) return "Minimum 3 characters";
    if (val.length > 30) return "Maximum 30 characters";
    if (!USERNAME_REGEX.test(val)) return "Only lowercase letters, numbers, . and _ allowed";
    if (val.startsWith(".") || val.startsWith("_")) return "Cannot start with . or _";
    return "";
  };

  const handleUsername = (val) => {
    const clean = val.toLowerCase().replace(/[^a-z0-9._]/g, "");
    setForm({ ...form, username: clean });
    setUsernameError(validateUsername(clean));
  };

  const submit = async (e) => {
    e.preventDefault();
    const uErr = validateUsername(form.username);
    if (uErr) { setUsernameError(uErr); return; }
    if (!form.phone.trim()) { toast.error("Phone number is required"); return; }
    if (form.password !== form.confirmPassword) { toast.error("Passwords do not match"); return; }
    if (form.password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (!termsAccepted) { toast.error("Please accept the Terms of Service and Privacy Policy"); return; }
    setLoading(true);
    try {
      const phone = `${form.countryCode}${form.phone.trim()}`;
        await register({ name: form.name, username: form.username, email: form.email, password: form.password, role, phone, company_name: role === "manager" ? form.companyName.trim() : undefined });
        if (workspace === "events" || workspace === "freelance") {
          await api.patch("/users/me", { last_workspace: workspace });
          await refresh();
        }
        toast.success("Account created! Check your email to verify.");
      nav(redirectTo);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 py-12">
      <span className="label-eyebrow text-muted-foreground">Step {step} of 2</span>
      <h1 className="mt-2 font-display text-4xl tracking-tighter">Create your EarnMate account</h1>
      <p className="mt-2 text-slate-600 text-sm">Already have one? <Link to={redirectTo !== "/" ? `/login?redirect=${encodeURIComponent(redirectTo)}` : "/login"} className="underline">Sign in</Link></p>

      {step === 1 && (
        <>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid="role-grid">
            {ROLES.map(r => {
              const Icon = r.icon;
              const selected = role === r.id;
              return (
                <button key={r.id} onClick={() => setRole(r.id)} data-testid={`role-${r.id}`}
                  className={`text-left p-6 rounded-sm border-2 transition ${selected ? "border-brand bg-brand-tint" : "border-slate-200 hover:border-brand hover:bg-brand-tint/40"}`}>
                  <Icon className="w-6 h-6" />
                  <p className="mt-3 font-display text-xl">{r.title}</p>
                  <p className="text-sm text-slate-600 mt-1">{r.desc}</p>
                </button>
              );
            })}
          </div>
          <button onClick={() => setStep(2)} className="btn-primary mt-8" data-testid="role-continue">Continue</button>
        </>
      )}

      {step === 2 && (
        <form onSubmit={submit} className="mt-10 max-w-md space-y-4" data-testid="register-form">

          {/* Google button */}
          <button type="button" onClick={() => {
            const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
            const callbackUrl = `${window.location.origin}/auth/callback?redirect=${encodeURIComponent(redirectTo)}`;
            window.location.href = `${backendUrl}/api/auth/google/login?redirect=${encodeURIComponent(callbackUrl)}`;
          }} className="btn-outline w-full" data-testid="google-register-btn">
            <svg className="w-4 h-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>
          <div className="flex items-center gap-3 text-xs text-muted-foreground"><div className="flex-1 h-px bg-slate-200"/>OR<div className="flex-1 h-px bg-slate-200"/></div>

          {/* Full name */}
          <div>
            <label className="label-eyebrow text-muted-foreground">Full name</label>
            <input className="input-base mt-2" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} data-testid="reg-name" />
          </div>

          {/* Username */}
          <div>
            <label className="label-eyebrow text-muted-foreground">Username <span className="text-red-500">*</span></label>
            <div className="relative mt-2">
              <span className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground text-sm pointer-events-none">@</span>
              <input
                className={`input-base pl-9 ${usernameError ? "border-red-400" : ""}`}
                required
                placeholder="your.username"
                value={form.username}
                onChange={e => handleUsername(e.target.value)}
                data-testid="reg-username"
              />
            </div>
            {usernameError
              ? <p className="text-xs text-red-500 mt-1">{usernameError}</p>
              : <p className="text-xs text-muted-foreground mt-1">Lowercase letters, numbers, . and _ only. No spaces.</p>
            }
          </div>

          {/* Email */}
          <div>
            <label className="label-eyebrow text-muted-foreground">Email</label>
            <input type="email" className="input-base mt-2" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} data-testid="reg-email" />
          </div>

          {/* Phone */}
          <div>
            <label className="label-eyebrow text-muted-foreground">Phone number <span className="text-red-500">*</span></label>
            <div className="flex mt-2 rounded-xl border border-slate-300 overflow-visible focus-within:border-brand focus-within:ring-1 focus-within:ring-brand">
              <CountryCodePicker
                value={form.countryCode}
                onChange={code => setForm({ ...form, countryCode: code })}
              />
              <input
                type="tel"
                className="flex-1 bg-background text-foreground text-sm px-3 py-3 outline-none min-w-0 rounded-r-xl"
                required
                placeholder="987654XXXX"
                maxLength={10}
                value={form.phone}
                onChange={e => setForm({ ...form, phone: e.target.value.replace(/\D/g, "").slice(0, 10) })}
                data-testid="reg-phone"
              />
            </div>
          </div>

          {/* Organization name — managers only */}
          {role === "manager" && (
            <div>
              <label className="label-eyebrow text-muted-foreground">Organization / company name</label>
              <input className="input-base mt-2" placeholder="e.g. Malabar Events Co." value={form.companyName} onChange={e => setForm({ ...form, companyName: e.target.value })} data-testid="reg-company-name" />
              <p className="text-xs text-muted-foreground mt-1">Shown to workers when you post jobs. Optional but recommended.</p>
            </div>
          )}

          {/* Password */}
          <div>
            <label className="label-eyebrow text-muted-foreground">Password</label>
            <div className="relative mt-2">
              <input type={showPassword ? "text" : "password"} className="input-base pr-10" required minLength={8} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} data-testid="reg-password" />
              <button type="button" onClick={() => setShowPassword(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-slate-600">
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          {/* Confirm Password */}
          <div>
            <label className="label-eyebrow text-muted-foreground">Confirm password</label>
            <div className="relative mt-2">
              <input type={showPassword ? "text" : "password"} className={`input-base pr-10 ${form.confirmPassword && form.password !== form.confirmPassword ? "border-red-400" : ""}`} required minLength={8} value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })} />
              <button type="button" onClick={() => setShowPassword(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-slate-600">
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
            {form.confirmPassword && form.password !== form.confirmPassword && (
              <p className="text-xs text-red-500 mt-1">Passwords do not match</p>
            )}
          </div>

          {/* Terms acceptance */}
          <div className="flex items-start gap-3">
            <input
              type="checkbox"
              id="terms"
              checked={termsAccepted}
              onChange={e => setTermsAccepted(e.target.checked)}
              className="mt-0.5 w-4 h-4 accent-brand flex-shrink-0"
            />
            <label htmlFor="terms" className="text-xs text-muted-foreground leading-relaxed cursor-pointer">
              By creating an account, I agree to EarnMate's{" "}
              <Link to="/terms" target="_blank" className="text-brand hover:underline">Terms of Service</Link>
              {" "}and{" "}
              <Link to="/privacy-policy" target="_blank" className="text-brand hover:underline">Privacy Policy</Link>.
            </label>
          </div>

          <div className="flex gap-3 pt-2">
            <button type="button" onClick={() => setStep(1)} className="btn-outline">Back</button>
            <button disabled={loading} className="btn-primary flex-1" data-testid="reg-submit">
              {loading ? "Creating…" : `Create ${role} account`}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
